// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container_2kEEl{display:flex}", ""]);
// Exports
exports.locals = {
	"container": "container_2kEEl"
};
module.exports = exports;
